import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import MoreActions from 'shared/ui/MoreActions/MoreActions';
import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import PlusWithButton from 'shared/ui/icons/General/PlusWithButton';
import {IUserOutput} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

import styles from './BatchEdit.module.scss';

export interface IAddFieldOption {
    key: string;
    label: () => string;
    isAvailable: (_user: IUserOutput | null) => boolean;
}

interface IAddFieldDropdownProps {
    addedFields: string[];
    user: IUserOutput | null;
    fields: IAddFieldOption[];
    onAdd: (_key: string) => void;
}

const AddFieldDropdown: React.FC<IAddFieldDropdownProps> = ({
    addedFields,
    user,
    fields,
    onAdd,
}) => {
    const availableFields = fields.filter(
        field => field.isAvailable(user) && !addedFields.includes(field.key),
    );

    const anchor = (
        <button
            type="button"
            className={cn(
                styles.addButton,
                isTranslate() ? styles.enAddButton : styles.ruAddButton,
            )}
            disabled={availableFields.length === 0}
        >
            <PlusWithButton />
            {t`Добавить поле`}
        </button>
    );

    if (availableFields.length === 0) {
        return anchor;
    }

    return (
        <MoreActions anchor={anchor} placement="bottomStart" arrow={false}>
            {availableFields.map(field => (
                <MoreActionsItem
                    key={field.key}
                    label={field.label()}
                    onClick={() => onAdd(field.key)}
                />
            ))}
        </MoreActions>
    );
};

export default AddFieldDropdown;
